export const SET_IS_SINGLE_PAYROLL_SHEET_LOADING = 'PAYROLL_SHEET/SET_IS_SINGLE_PAYROLL_SHEET_LOADING';
export const SET_PAYROLL_SHEET_EMPLOYEE_UUID = 'PAYROLL_SHEET/SET_PAYROLL_SHEET_EMPLOYEE_UUID';
export const SET_COMMISSIONED_UUID = 'PAYROLL_SHEET/SET_COMMISSIONED_UUID';
export const SET_PAYROLL_SHEET = 'PAYROLL_SHEET/SET_PAYROLL_SHEET';
export const CLEAR_PAYROLL_SHEET = 'PAYROLL_SHEET/CLEAR_PAYROLL_SHEET';
export const SET_PAYROLL_SHEET_LIST = 'PAYROLL_SHEET/SET_PAYROLL_SHEET_LIST';
export const SET_PAYROLL_SHEET_LIST_IS_LOADING = 'PAYROLL_SHEET/SET_PAYROLL_SHEET_LIST_IS_LOADING';